export default __webpack_public_path__ + "static/media/kitchen3-afterC-768w.d4a3b04d.avif";